import React, { useState, useEffect, useRef } from "react";
import { useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import { Col, Container, Content, FlexboxGrid, Header, Input, InputGroup, Navbar, Panel, Stack, Table } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { MainLogo } from "../utils/icons";
import axios from "axios";
import image from "assets/img/full-screen-image-2.jpg";
import loader from "assets/img/init.svg";
import r404 from "assets/img/404.svg";
import r403 from "assets/img/403.svg";
import r500 from "assets/img/500.svg";
import r503 from "assets/img/503.svg";


function PDFView() {
    const site = useSelector(state => state.site);
    const [loadingState, setLoadingState] = useState(0);
    const [currentState, setCurrentState] = useState("buscando catálogo ...");
    const objectURL = useRef(null);
    const [cookies, setCookie] = useCookies(['uuid']);
    const genUUID = () => ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));

    useEffect(() => {
        console.log('useEffect begin');
        const uuid = !cookies.uuid ? genUUID() : cookies.uuid
        if (!cookies.uuid)
            setCookie('uuid', uuid, { path: '/', sameSite: 'none', domain: '.wisesoft.ar', secure: true, expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5)) });
        const preload = (src) => {
            return new Promise((resolve, reject) => {
                //lo guardo cómo blob
                axios
                    .get(src, { responseType: 'blob' })
                    .then((response) => {
                        console.log(response);
                        objectURL.current = window.URL.createObjectURL(response.data, { type: 'application/pdf' });
                        console.log(objectURL.current);
                        resolve();
                    }).catch((e) => { reject(e); setLoadingState(-4);});
            })
        }
        const fetchData = async () => {
            await axios
                .get(`${site.site.apiServer}/catalogo/view${window.location.pathname}`, { withCredentials: true })
                .then(async (response) => {
                    console.log(response.data);
                    console.log(window.location.pathname.includes('pdf'));
                    if (response.data.result) {
                        setCurrentState("descargando archivo PDF ...");
                        if (response.data.data.length === 1) {
                            preload(`${site.site.apiServer}/catalogo/${window.location.pathname.includes('pdfweb') ? 'pdfweb' : 'pdf'}/${response.data.data[0].publishKey}`)
                                .then(() => { setLoadingState(1); /*window.location.replace(objectURL.current);*/ })
                                .catch((e) => { setLoadingState(-5); });
                        }
                        else
                            setLoadingState(-1);
                    } else
                        setLoadingState(-1);
                })
                .catch((e) => {
                    if (e.response && e.response.data && e.response.data.detail === 'NOT_FOUND') {
                        setLoadingState(-1);
                    } else if (e.response && e.response.data && e.response.data.detail === 'EXPIRED') {
                        setLoadingState(-2);
                    } else if (e.response && e.response.data && e.response.data.detail === 'INACTIVE') {
                        setLoadingState(-3);
                    } else {
                        setLoadingState(-4);
                    }
                });
        }
        var head = document.head;
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = "./defaultVL.css";
        head.appendChild(link);
        fetchData();
        return () => { head.removeChild(link); console.log('useEffect end'); }
    }, [site]);
    function Iframe(props) {
        return (<div dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }} />);
    }

    return (
        <div className="wrapper wrapper-full-page">
            <div class="full-page section-image" data-color="black">
                <Container>
                    <Header>
                        <Navbar appearance="subtle">
                            <Navbar.Brand href="https://wisesoft.com.ar" target="_blank">
                                <Icon as={MainLogo} style={{ fontSize: 36, marginRight: "5px", opacity: "0.5" }} />wiseSoft - Catálogo en línea
                            </Navbar.Brand>
                        </Navbar>
                    </Header>
                    <Content style={{ padding: "20px" }}>
                        {loadingState === 0 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} colspan={24} md={5} style={{ color: "#fff" }}>
                                    <img src={loader} style={{ display: "block", margin: "auto", width: 150 }} alt="loading" />
                                    <h5 style={{ marginTop: 20, fontWeight: "normal", textAlign: "center" }}>{currentState}</h5>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === 1 && objectURL.current != null && (
                            <Iframe iframe={`<iframe style="position:fixed; left: 0; top: 0; bottom:0; right:0;" frameborder="no" allowtransparency="true" src="${objectURL.current}" type="application/pdf" width="100%" height="100%" style="overflow: auto;"></iframe>`} />
                        )}
                        {loadingState === -1 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r404} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>No se encontró el catálogo solicitado</h4>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === -2 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r403} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>Expiró la vigencia del catálogo solicitado</h4>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === -3 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r503} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>La publicación se encuentra en pausa...</h4>
                                    <h5 style={{ marginTop: 10, textAlign: "center", opacity: .6, fontWeight: "normal" }}>Por favor, intente ingresar nuevamente en unos instantes.</h5>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === -4 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r500} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>Pedimos disculpas, el servidor no está respondiendo...</h4>
                                    <h5 style={{ marginTop: 10, textAlign: "center", opacity: .6, fontWeight: "normal" }}>Por favor, intente ingresar nuevamente en unos instantes.</h5>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === -5 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r503} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>Pedimos disculpas, el servidor está reportando un error...</h4>
                                    <h5 style={{ marginTop: 10, textAlign: "center", opacity: .6, fontWeight: "normal" }}>Por favor, intente ingresar nuevamente en unos instantes.</h5>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                    </Content>
                </Container>
                <div class="full-page-background" style={{ backgroundImage: `url(${image})` }}></div>
            </div>
        </div>
    )
}

export default PDFView;